import { Input } from '@/components/ui/input';
import useGeneratorStore from '@/state/generator-store';
import React from 'react';

const TrackNameInput: React.FC = () => {
  const { register } = useGeneratorStore((state) => ({
    register: state.register,
  }));

  return (
    <div className="relative flex items-center">
      <Input
        className="bg-gray-900 h-10 min-w-40 py-0 px-2 rounded-lg text-white text-[0.8rem] border-[#474A4C] font-pressura-mono placeholder:text-jen-content-tertiary"
        style={{
          background: 'linear-gradient(#191A1B, #1E2021)',
          boxShadow: 'inset 2px 2px 12px rgba(0, 0, 0, 1)',
        }}
        autoCorrect="off"
        autoComplete="off"
        autoCapitalize="off"
        spellCheck={false}
        {...register('trackName')}
        placeholder="ENTER TRACK NAME"
      />
    </div>
  );
};

export default TrackNameInput;
